export default __webpack_public_path__ + "static/media/setion02_kv01_m.b1bad454.png";